<ng-container *ngIf="viewingDocument$ | async as selectedDocument">
	<div class="flex flex-col h-full">
		<div
			class="flex bg-red-lighter border rounded-md text-red p-2 my-2 items-center"
			*ngIf="errorMessage"
		>
			<div
				class="px-2"
				*ngIf="
					!showLongMessage && errorMessage.length > longErrorMessageMaxLength
				"
			>
				<span [innerHtml]="errorMessage"></span>
				&nbsp;
				<span
					(click)="toggleShowLongMessage(selectedDocument?.errorMessage)"
					class="underline cursor-pointer"
					>Read more</span
				>
			</div>
			<div
				class="px-2"
				*ngIf="
					showLongMessage && errorMessage.length > longErrorMessageMaxLength
				"
			>
				<span [innerHtml]="errorMessage"></span>
				&nbsp;
				<span
					(click)="toggleShowLongMessage(selectedDocument?.errorMessage)"
					class="underline cursor-pointer"
					>Show less</span
				>
			</div>
			<p class="px-2" *ngIf="errorMessage.length <= longErrorMessageMaxLength">
				<span [innerHtml]="errorMessage"></span>
			</p>
		</div>
		<app-html-editor
			class="h-full"
			[document]="html"
			[documentId]="documentId"
			(onChange)="updateDocument($event)"
			(triggerSettings)="toggleDocumentSettings()"
			(workingChange)="onWorkingChange($event)"
		></app-html-editor>
	</div>
</ng-container>
